export const FIELD_NONE = "none";
export const OPERATOR_NONE = "none";

export function rowIsStarted(row, fieldNone = FIELD_NONE, operatorNone = OPERATOR_NONE) {
  return (
    (row.field && row.field !== fieldNone) ||
    (row.operator && row.operator !== operatorNone) ||
    String(row.value ?? "").trim() !== "" ||
    String(row.headerName ?? "").trim() !== ""
  );
}

export function rowIsComplete(row, fieldNone = FIELD_NONE, operatorNone = OPERATOR_NONE) {
  return (
    row.field &&
    row.field !== fieldNone &&
    row.operator &&
    row.operator !== operatorNone
  );
}
